import { toArray as _toArray, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { globalEventDispatcher } from '../GlobalEventDispatcher.js';

/* eslint-disable prefer-spread */

function attachEvents(_ref) {
  var internal = _ref.internal,
      global = _ref.global;
  internal.forEach(function (_ref2) {
    var _ref3 = _toArray(_ref2),
        el = _ref3[0],
        params = _ref3.slice(1);

    el.addEventListener.apply(el, params);
  });
  if (global) global.forEach(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        name = _ref5[0],
        func = _ref5[1];

    return globalEventDispatcher(name).add(func);
  });
}
function removeEvents(_ref6) {
  var internal = _ref6.internal,
      global = _ref6.global;
  internal.forEach(function (_ref7) {
    var _ref8 = _toArray(_ref7),
        el = _ref8[0],
        params = _ref8.slice(1);

    return el.removeEventListener.apply(el, params);
  });
  if (global) global.forEach(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        name = _ref10[0],
        func = _ref10[1];

    return globalEventDispatcher(name).remove(func);
  });
}

export { attachEvents, removeEvents };
